"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Annotation = _interopRequireDefault(require("./Annotation"));

var _User = _interopRequireDefault(require("./User"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * AnnotationCollection class to hold all properties and methods related to a list of Annotations.
 */
var AnnotationCollection =
/**
 * Constructor
 *
 * @param {Object} data AnnotationCollection object returned from the RedHawk API.
 * @param {String} headers The AnnotationCollection headers.
 */
function AnnotationCollection() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, AnnotationCollection);

  this.type = data.type;
  this.id = data.id;
  this.count = data.total;
  this.annotations = data.first.items.map(function (annotation) {
    return new _Annotation["default"](annotation);
  });
  this.etag = headers.etag;
  this.retryAfter = headers.retryAfter;
  var commenters = data['adobe:annotCollectionMetadata'] && data['adobe:annotCollectionMetadata']['adobe:userInfo'];

  if (commenters) {
    var processedCommenters = [];
    Object.keys(commenters).forEach(function (key) {
      processedCommenters.push(new _User["default"](commenters[key], key));
    });
    this.commenters = processedCommenters;
  }
};
/**
 * Exports the AnnotationCollection class.
 */


var _default = AnnotationCollection;
exports["default"] = _default;